export enum TaskTarget {
    toplu = "toplu",
    dosya = "dosya",
    borclu = "borclu"
}